import React from 'react';
import InputTypeSwitch from '../../formElements/InputTypeSwitch';
import SimpleFormBeforeAfterSection from './SimpleFormBeforeAfterSection';
import { checkCondition } from '../../utility/filterSchema';
import { useFormikContext } from 'formik';
import SectionContainer from './SectionContainer';

function SimpleFormSection({ section, beforeData, data, embedVersion }) {
  const { values } = useFormikContext();

  const { sectionCondition, onlyInEmbeddedForm, excludeFromEmbeddedForm } =
    section;

  if (sectionCondition) {
    const conditionMet = checkCondition(sectionCondition, {
      ...data,
      ...values,
    });
    if (!conditionMet) return null;
  }

  if (
    (onlyInEmbeddedForm && !embedVersion) ||
    (excludeFromEmbeddedForm && embedVersion)
  ) {
    return null;
  }

  const switchSectionType = (type) => {
    switch (type) {
      case 'before-after':
        return (
          <SimpleFormBeforeAfterSection
            section={section}
            beforeData={beforeData}
            data={data}
          />
        );
      default:
        return (
          <SectionContainer
            label={section.sectionLabel}
            id={section.sectionValue}
            description={section.sectionDescription}
            defaultOpen={!section.sectionCollapsed}
            toggleSection={!section.sectionNoToggle}
            noHeader={section.sectionNoHeader}
          >
            {section.schema.map((field, ind) => (
              <React.Fragment key={field.name || field.label}>
                <InputTypeSwitch
                  key={field.name || field.label}
                  elem={field}
                  index={ind}
                  externalData={data}
                  embedVersion={embedVersion}
                />
              </React.Fragment>
            ))}
          </SectionContainer>
        );
    }
  };

  return switchSectionType(section.sectionType);
}

export default SimpleFormSection;
